/**
 * `portfolio` namespace — Korean translations.
 *
 * Mirrors `en/portfolio.ts` exactly; the `Record<PortfolioKey, string>`
 * annotation makes a missing or misspelled key a compile error, so this file
 * cannot drift from the canonical English source. Concise 명사형/합니다체; glossary
 * terms (포트폴리오/보유 종목/입금/출금/시장 손익) applied consistently. Ticker/통화
 * 코드는 원문(`{currency}` 그대로) 유지.
 */
import type { PortfolioKey } from "../en/portfolio";

export const portfolio: Record<PortfolioKey, string> = {
  // ── route chrome ──
  accountsEyebrow: "계좌",
  description: "기간별 가치 추이, 시장 손익과 입출금 분해, 자산 배분, 보유 종목, 입출금 내역.",

  // ── summary strip ──
  noSnapshotTitle: "아직 스냅샷이 없습니다",
  noSnapshotBody:
    "포트폴리오 스냅샷은 장 세션 경계에서 기록됩니다. 첫 스냅샷이 기록되면 값이 표시됩니다.",
  totalValue: "총 자산",
  asOf: "{date} 기준",
  stocks: "주식",
  cash: "현금",
  netDeposits: "순입출금",
  marketPnlHint: "시장 손익",

  // ── manual snapshot ──
  snapshotNow: "지금 스냅샷 기록",
  snapshotQueued: "스냅샷이 큐에 들어갔습니다 — 잠시 후 새로고침하세요.",

  // ── holdings ──
  holdingsTitle: "보유 종목",
  holdingsGateMessage:
    "실시간 보유 종목을 보려면 설정에서 Toss Securities 자격 증명을 연결하고 인증해야 합니다.",
  openSettings: "설정 열기",
  positionCount: "{count}개 종목",
  holdingsEmpty: "이 계좌에 보유 중인 종목이 없습니다.",
  colSymbol: "종목",
  colQty: "수량",
  colAvgCost: "평균 매입가",
  colLast: "현재가",
  colMarketValue: "평가금액",
  colUnrealizedPnl: "평가 손익",
  colToday: "당일",

  // ── cashflow ledger (read-only) ──
  cashflowTitle: "입출금 내역",
  cashflowSubtitle: "입금, 출금, 배당, 수수료",
  cashflowEmpty: "아직 기록된 입출금 내역이 없습니다.",
  colInBase: "{currency} 환산",
  badgeExternal: "외부",
  badgeInferred: "추정",

  // ── cashflow ledger column headers ──
  fieldKind: "유형",
  fieldDate: "날짜",
  fieldAmount: "금액",
  fieldNote: "메모",

  // ── cashflow kinds (badge labels) ──
  kindDeposit: "입금",
  kindWithdrawal: "출금",
  kindDividend: "배당",
  kindInterest: "이자",
  kindFee: "수수료",
  kindTax: "세금",
};
